import React from "react";
import Nav from "../../../constants/nav";
import { NavLink } from "react-router-dom";
import { FaPlus } from "react-icons/fa";

type INavBarItem = {
  open: boolean;
  onClick: () => void;
};

const NavBarItem: React.FC<INavBarItem> = ({ open, onClick }) => {
  const nav_ref = React.useRef<HTMLDivElement>(null);

  const handleClickOutside = React.useCallback(
    (event: MouseEvent) => {
      if (nav_ref.current && !nav_ref.current.contains(event.target as Node)) {
        onClick(); // Close menu when clicking outside
      }
    },
    [onClick]
  );

  const handleResize = React.useCallback(() => {
    if (window.innerWidth >= 1024 && open) {
      onClick(); // Close menu when screen width hits `lg` (1024px)
    }
  }, [onClick, open]);

  React.useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, [handleClickOutside, handleResize]); // Ensure proper cleanup

  return (
    <div
      ref={nav_ref}
      className={`${
        open
          ? "absolute w-52 top-20 grid bg-white/90 backdrop-blur-md px-2 py-4 right-4 rounded-2xl shadow-lg z-50 transition-all ease-in-out duration-300"
          : "hidden"
      } lg:flex lg:relative`}
    >
      {Nav.map((item) => (
        <NavLink
          key={item.title} // Stable key for better React rendering
          to={item.link}
          onClick={onClick}
          className={({ isActive, isPending }) =>
            `${
              isPending || (isActive ? "text-primary-900" : "text-dark")
            } font-medium hover:text-primary-900 py-3 lg:py-2 px-5 lg:px-3 md:text-center transition-colors duration-300`
          }
        >
          <div className="relative text-center text-[1rem]">
            <div className="flex justify-between items-center">
              <span>{item.title}</span>
              <FaPlus className="lg:hidden" />
            </div>
          </div>
        </NavLink>
      ))}
    </div>
  );
};

export default NavBarItem;
